export const USERNAME_FIELD = 'login';
export const PASSWORD_FIELD = 'password';
export const SIGN_IN_FETCHING = 'SIGN_IN_FETCHING';